import { AxiosResponse } from 'axios';
import { BaseService } from '../../../../../services/route.service';
import { LeadRequest, LeadUpdateRequest, MoveLeadRequest } from './requests/lead.request';
import {
    LeadCustomFieldValueResponse, LeadDetailResponse, LeadOptionResponse, LeadResponse,
} from './responses/lead.response';

export class CrmLeadService extends BaseService {
    protected get resourceName(): string {
        return 'crm/leads';
    }

    public async create(body: LeadRequest): Promise<AxiosResponse<{ data: LeadResponse }>> {
        return await this.post(body);
    }

    /// Leads em aberto para seletor; separado da busca global porque a lista precisa vir pronta.
    public async options(): Promise<AxiosResponse<{ data: LeadOptionResponse[] }>> {
        return await this.get('options');
    }

    public async update(id: string, body: LeadUpdateRequest): Promise<AxiosResponse<{ data: LeadResponse }>> {
        return await this.put(id, body);
    }

    /// Só o status: o PUT troca o lead inteiro, e card e painel não têm o resto para reenviar.
    public async changeStatus(id: string, statusId: string): Promise<AxiosResponse<{ data: LeadResponse }>> {
        return await this.patch(`${id}/status`, { statusId });
    }

    /// Valor estimado e previsão de fechamento.
    public async updateDeal(
        id: string,
        body: { value: number | null; expectedCloseDate: string | null }
    ): Promise<AxiosResponse<{ data: LeadResponse }>> {
        return await this.patch(`${id}/deal`, body);
    }

    /// Aplica o que a IA achou. Nulo não mexe; da pessoa só preenche o vazio.
    public async complete(
        id: string,
        body: {
            value: number | null;
            expectedCloseDate: string | null;
            email: string | null;
            cnpj: string | null;
            companyName: string | null;
        }
    ): Promise<AxiosResponse<{ data: LeadResponse }>> {
        return await this.patch(`${id}/complete`, body);
    }

    public async move(id: string, body: MoveLeadRequest): Promise<AxiosResponse<void>> {
        return await this.patch(`${id}/move/${body.targetColumnId}`, {
            targetSortOrder: body.targetSortOrder,
        });
    }

    /// userId nulo devolve o lead para a fila.
    public async assign(id: string, userId: string | null): Promise<AxiosResponse<void>> {
        return await this.patch(`${id}/assign`, { userId });
    }

    /// Substitui o conjunto inteiro: lista vazia tira todas as tags.
    public async setTags(id: string, tagIds: string[]): Promise<AxiosResponse<void>> {
        return await this.put(`${id}/tags`, { tagIds });
    }

    /// Todos os campos ativos de uma vez: o que não for enviado fica vazio.
    public async setCustomFields(id: string, values: LeadCustomFieldValueResponse[]): Promise<AxiosResponse<void>> {
        return await this.put(`${id}/custom-fields`, { values });
    }

    public async reorder(columnId: string, orderedIds: string[]): Promise<AxiosResponse<void>> {
        return await this.patch(`reorder/${columnId}`, { orderedIds });
    }

    /// Tudo que a tela do lead mostra numa chamada: lead, etapas do quadro e números do resumo.
    public async detail(id: string): Promise<AxiosResponse<{ data: LeadDetailResponse }>> {
        return await this.get(`${id}/detail`);
    }

    /// Marca ganho, perda ou reabre; ação própria do lead, independe de arrastar o card.
    public async setOutcome(
        id: string,
        body: {
            outcome: number;
            lossReasonId?: string | null;
            lossNote?: string | null;
            closedValue?: number | null;
        }
    ): Promise<AxiosResponse<LeadResponse>> {
        return await this.patch(`${id}/outcome`, body);
    }
}
